import { ReactNode } from 'react';

import styles from './Receipt.module.scss';

type ReceiptHeaderProps = {
  children?: ReactNode;
};

export const ReceiptHeader = ({ children }: ReceiptHeaderProps) => (
  <div className={styles.header}>{children}</div>
);
